export class Category {
  level1Id = ""
  level1Name = ""
  level1Status = ""

  level2Id = ""
  level2Name = ""
  level2Status = ""

  level3Id = ""
  level3Name = ""
  level3Status = ""

  source = ""
  createdAt = ""
  createdTimestamp = 0
  updatedAt: string | null = null

  constructor(mapping?: any) {
    if (mapping) {
      this.level1Id = mapping?.level_1_id
      this.level1Name = mapping?.level_1_name
      this.level1Status = mapping?.level_1_status

      this.level2Id = mapping?.level_2_id
      this.level2Name = mapping?.level_2_name
      this.level2Status = mapping?.level_2_status

      this.level3Id = mapping?.level_3_id
      this.level3Name = mapping?.level_3_name
      this.level3Status = mapping?.level_3_status

      this.source = mapping?.source
      this.createdAt = mapping?.created_at
      this.createdTimestamp = mapping?.created_timestamp
      this.updatedAt = mapping?.updated_at
    }
  }
}
